import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h3>Sorry page not found</h3>
            <p>404 Error!!</p>
        </div>
    );
};

export default NoMatch;